/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { PrintDialogComponent } from './dialog/print-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

export class PrintCommand extends MapCommand {

    private dialog: MatDialog;

    invoke() {
        this.dialog.open(PrintDialogComponent, {
            width: '320px',
        }).afterClosed().pipe(
            take(1)
        ).subscribe(() => this.deactivate$.next());
    }

    protected onCommandInit() {
        super.onCommandInit();
        this.dialog = this.deps['dialog'];
    }
}
